import * as XLSX from 'xlsx';

export function DownloadExcelAnalytics(deliveries, selectedDate) {
  // Format date for filename
  const dateStr = selectedDate.replace(/-/g, '');
  
  // Create header row
  const headers = [
    "ID",
    "Destinatario",
    "Teléfono",
    "Dirección",
    "Distrito",
    "Producto",
    "Estado",
    "Por Cobrar",
    "Cobrado",
    "Fecha Entrega",
    "Hora Llegada",
    "Notas",
    "Notas Conductor"
  ];

  // Map delivery data to rows
  const rows = deliveries.map(delivery => {
    // Calculate total cobrado (charged + fastmax_transfer_amount)
    const totalCobrado = parseFloat(delivery.charged || 0) + parseFloat(delivery.fastmax_transfer_amount || 0);
    
    return [
      delivery.id || '',
      delivery.recipient_name || '',
      delivery.recipient_phone || '',
      delivery.address || '',
      delivery.district || '',
      delivery.product || '',
      delivery.status || '',
      delivery.charge ? `S/ ${parseFloat(delivery.charge).toFixed(2)}` : '',
      totalCobrado > 0 ? `S/ ${totalCobrado.toFixed(2)}` : '',
      delivery.delivery_date ? new Date(delivery.delivery_date).toLocaleDateString('es-PE') : '',
      delivery.arrival_time ? new Date(delivery.arrival_time).toLocaleString('es-PE') : '',
      delivery.notes || '',
      delivery.notes_driver || ''
    ];
  });

  // Combine headers and data
  const data = [headers, ...rows];

  // Create worksheet
  const ws = XLSX.utils.aoa_to_sheet(data);

  // Set column widths
  const columnWidths = [
    { wch: 8 },  // ID
    { wch: 25 }, // Destinatario
    { wch: 15 }, // Teléfono
    { wch: 40 }, // Dirección
    { wch: 20 }, // Distrito
    { wch: 30 }, // Producto
    { wch: 12 }, // Estado
    { wch: 12 }, // Por Cobrar
    { wch: 12 }, // Cobrado
    { wch: 15 }, // Fecha Entrega
    { wch: 20 }, // Hora Llegada
    { wch: 30 }, // Notas
    { wch: 30 }  // Notas Conductor
  ];
  ws['!cols'] = columnWidths;

  // Create workbook
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Entregas");

  // Generate filename
  const filename = `Entregas_${dateStr}.xlsx`;

  // Download file
  XLSX.writeFile(wb, filename);
}

export function DownloadExcelProvinciaAnalytics(deliveries, selectedDate) {
  // Format date for filename
  const dateStr = selectedDate.replace(/-/g, '');
  
  // Create header row for provincia deliveries
  const headers = [
    "ID",
    "Destinatario",
    "DNI",
    "Teléfono",
    "Provincia",
    "Distrito",
    "Dirección",
    "Agencia",
    "Código Recojo",
    "Producto",
    "Estado",
    "Por Cobrar",
    "Anticipo",
    "Fecha Entrega",
    "Notas",
    "Comprobantes"
  ];

  // Map provincia delivery data to rows
  const rows = deliveries.map(delivery => {
    return [
      delivery.id || '',
      delivery.recipient_name || '',
      delivery.recipient_dni || '',
      delivery.recipient_phone || '',
      delivery.province || '',
      delivery.district || '',
      delivery.address || '',
      delivery.agency_address || '',
      delivery.agency_pickup_code || '',
      delivery.product || '',
      delivery.status || '',
      delivery.charge ? `S/ ${parseFloat(delivery.charge).toFixed(2)}` : '',
      delivery.deposit_advance ? `S/ ${parseFloat(delivery.deposit_advance).toFixed(2)}` : '',
      delivery.delivery_date ? new Date(delivery.delivery_date).toLocaleDateString('es-PE') : '',
      delivery.notes || '',
      delivery.images && delivery.images.length > 0 ? `${delivery.images.length} imagen(es)` : 'Sin imágenes'
    ];
  });

  // Combine headers and data
  const data = [headers, ...rows];

  // Create worksheet
  const ws = XLSX.utils.aoa_to_sheet(data);

  // Set column widths
  const columnWidths = [
    { wch: 8 },  // ID
    { wch: 25 }, // Destinatario
    { wch: 12 }, // DNI
    { wch: 15 }, // Teléfono
    { wch: 20 }, // Provincia
    { wch: 20 }, // Distrito
    { wch: 40 }, // Dirección
    { wch: 35 }, // Agencia
    { wch: 15 }, // Código Recojo
    { wch: 30 }, // Producto
    { wch: 12 }, // Estado
    { wch: 12 }, // Por Cobrar
    { wch: 12 }, // Anticipo
    { wch: 15 }, // Fecha Entrega
    { wch: 30 }, // Notas
    { wch: 15 }  // Comprobantes
  ];
  ws['!cols'] = columnWidths;

  // Create workbook
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Entregas Provincia");

  // Generate filename
  const filename = `Entregas_Provincia_${dateStr}.xlsx`;

  // Download file
  XLSX.writeFile(wb, filename);
}